<template>
  <K2Modal
    :title="title"
    :dialog="modal?.name === 'showSupportingDocumentModal'"
    class="customHeader"
    :show-close="true"
    :hide-footer="true"
    bodyClass="apfSupportingDoc"
    @handleClose="$emit('handleClose')"
    :center="false"
  >
    <div v-if="selected && group === 'MIS'">
      <APFMISSupportingDocument />
    </div>
    <div v-else-if="selected && group === 'EIS'">
      <ApfEbisSupportingDocument />
    </div>
    <div v-else-if="selected && preschoolInfo">
      <ApfPreSupportingDocument :preschoolInfo="preschoolInfo" :schools="schools" :selected="selected" />
    </div>
    <div v-else>
      <ApfEhSupportingDocument :preschoolInfo="preschoolInfo" :schools="schools" :selected="selected" />
    </div>
  </K2Modal>
</template>
<script>
import K2Modal from '@/uiComponents/k2Modal/k2Modal'
import ApfPreSupportingDocument from '@/pages/application/texts/supportingDocument/ApfPreSupportingDocument'
import ApfEhSupportingDocument from '@/pages/application/texts/supportingDocument/ApfEhSupportingDocument'
import APFMISSupportingDocument from '@/pages/application/texts/supportingDocument/ApfMISSupportingDocument'
import ApfEbisSupportingDocument from '@/pages/application/texts/supportingDocument/ApfEbisSupportingDocument'

export default {
  name: 'SupportDocumentModal',
  props: ['modal', 'title', 'preschoolInfo', 'schools', 'selected', 'group'],
  components: { K2Modal, ApfPreSupportingDocument, ApfEhSupportingDocument, APFMISSupportingDocument, ApfEbisSupportingDocument },
}
</script>
